<template lang="pug">
.video-container(:class="[spacingTop, spacingBottom, backgroundColor]")
    .container.mx-auto
        .video-wrap(:class="layout")
            .video-info
                h3.video-title(v-if="videoTitle") {{ videoTitle }}
                .video-desc.rte-area(v-if="videoDesc" v-html="videoDesc") 
            .video-box(v-if="videoSource === 'video_upload'")
                Intern(:video="videoObject", :videoThumb="videoThumb", :videoProperties="videoProperties")
            .video-box(v-else)
                Extern(:video="video", :provider="videoProvider")
</template>

<script>
import Intern from './Intern';
import Extern from './Extern';

export default {
    name: 'Video',
    components: {
        Intern,
        Extern
    },
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    computed: {
        videoSource() {
            let videoSource = 'video_upload';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'video_source');
                if (setting && setting.value !== undefined) videoSource = setting.value;
            }
            return videoSource;
        },

        layout() {
            let layout = 'video_top';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'video_position');
                if (setting && setting.value !== undefined) layout = setting.value;
            }
            return layout;
        },

        backgroundColor() {
            let backgroundColor = 'bg_white';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'background_color');
                if (setting && setting.value !== undefined) backgroundColor = setting.value;
            }
            return backgroundColor;
        },

        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },

        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        },

        contents() {
            return this.section.contents || [];
        },

        media() {
            let media = this.contents.find(content => content.key === 'media')
            return media.media;
        },

        videoTitle() {
            let videoTitle = false;
            if(this.contents.find(content => content.key === 'title')) {
                videoTitle = this.contents.find(content => content.key === 'title');
                videoTitle = videoTitle.title;
            }
            return videoTitle
        },

        videoDesc() {
            let videoDesc = false;
            if(this.contents.find(content => content.key === 'content')) {
                videoDesc = this.contents.find(content => content.key === 'content');
                videoDesc = videoDesc.text;
            }
            
            return videoDesc
        },

        videoObject() {
            return this.media.find(el => el.type === 'video');
        },

        videoProperties() {
            let autoplay = false;
            let muted = false;

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'autoplay');
                if (setting && setting.value !== undefined) autoplay = setting.value;
            }

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'muted');
                if (setting && setting.value !== undefined) muted = setting.value;
            }

            return {
                autoplay: autoplay,
                muted: muted
            }

        },

        videoThumb() {
            return this.contents.find(content => content.key === 'image');
        },

        video() {
            return this.contents.find(content => content.key === 'video');
        },

        videoSettings() {
            return this.video.settings || [];
        },

        videoProvider() {
            return this.videoSettings.find(setting => setting.key === 'type');
        }

    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"
.video-info
    @apply mb-4
    .video-title
        @apply text-2xl
        color: $color-primary
    .video-desc
        ::v-deep
          a
            color: $color-secondary
            &:hover
                @apply underline
          strong
            @apply font-semibold
          ul
            @apply list-disc list-outside ml-4
            li
              padding: 4px 0
          ol
            @apply list-decimal list-outside ml-4
            li
              padding: 4px 0

.video-wrap
    &.video_right,
    &.video_left
        @apply grid grid-cols-1 gap-8
        @screen lg
           @apply grid grid-cols-2 gap-8 

    &.video_left
        .video-box
            @apply order-1
        .video-info
            @apply order-2

    &.video_top
        .video-info
            @apply mb-6

    .video-info
        .video-desc
            @apply mt-4
</style>
